import { authedJson } from '../api/client';

export type SprintStatus = 'PLANNED' | 'ACTIVE' | 'CLOSED';

export interface Sprint {
  sprintId: string;
  workspaceId: string;
  name: string;
  startDate: string;
  endDate: string;
  status: SprintStatus;
  createdBy: string;
  createdAt: number;
  updatedAt: number;
}

type GetToken = () => string | null;
type DoRefresh = () => Promise<boolean>;

export const sprintsApi = {
  list: (workspaceId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<{ sprints: Sprint[] }>(`/workspaces/${workspaceId}/sprints`, { method: 'GET' }, getToken, doRefresh),

  create: (
    workspaceId: string,
    name: string,
    startDate: string,
    endDate: string,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Sprint>(
      `/workspaces/${workspaceId}/sprints`,
      { method: 'POST', body: JSON.stringify({ name, startDate, endDate }) },
      getToken,
      doRefresh,
    ),

  get: (workspaceId: string, sprintId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Sprint>(`/workspaces/${workspaceId}/sprints/${sprintId}`, { method: 'GET' }, getToken, doRefresh),

  update: (
    workspaceId: string,
    sprintId: string,
    updates: Partial<Pick<Sprint, 'name' | 'startDate' | 'endDate' | 'status'>>,
    getToken: GetToken,
    doRefresh: DoRefresh,
  ) =>
    authedJson<Sprint>(
      `/workspaces/${workspaceId}/sprints/${sprintId}`,
      { method: 'PUT', body: JSON.stringify(updates) },
      getToken,
      doRefresh,
    ),

  close: (workspaceId: string, sprintId: string, getToken: GetToken, doRefresh: DoRefresh) =>
    authedJson<Sprint>(
      `/workspaces/${workspaceId}/sprints/${sprintId}/close`,
      { method: 'POST' },
      getToken,
      doRefresh,
    ),
};
